import store from "src/store";
function checkforReadyStepsCoach() {
    if (store.getters['currentUser/getCurrentUsersRole'] == "MANAGEMENT") {
        if (window.location.hostname == "www.setpointhealth.com") {
            console.log("CHECKFORREADYSTEPS::Readysteps check passed. Enabling Ready Steps Features")
            return true
        }
    }
    return false
}

export {
    checkforReadyStepsCoach
}